import React from 'react';
import useCustomer from 'hooks/useCustomer';
import EditCustomer from 'containers/Administration/Customers/EditCustomer/EditCustomer';
import Loading from 'components/Loading';
import NoMatch from 'containers/NoMatch';

const Account = () => {
  const { customerId, loading } = useCustomer();

  if (loading) {
    return <Loading />;
  }

  if (!customerId) {
    return <NoMatch />;
  }

  return (
    <EditCustomer customerId={customerId} />
  );
};

export default Account;
